import React from 'react';
import { useAxiosState } from './useAxios';

/**
 * Treat URL as 3rd party.
 * Data source: {@link https://docs.google.com/spreadsheets/d/1o0OqgFC8AMTRAvuUAEWNBeZeK8qb0AytVi4_491Nqp8/edit?gid=0#gid=0}
 */
const breakingChangesUrl = `${process.env.REACT_APP_BACKEND}/getSheet?sheet=1o0OqgFC8AMTRAvuUAEWNBeZeK8qb0AytVi4_491Nqp8&sheetName=Changes`;

export interface BreakingChangeInput {
  version: string;
  date: string;
  fixed: string;
  changed: string;
  added: string;
  removed: string;
}
export interface BreakingChange {
  version: string;
  date: string;
  fixed: string[];
  changed: string[];
  added: string[];
  removed: string[];
}

function getLines(s: string) {
  return s.split(/\r?\n/g).filter((l) => !!l);
}

export function useBreakingChanges() {
  const { value: breakingChangesInput, status, error } = useAxiosState<BreakingChangeInput[]>([], breakingChangesUrl);

  const breakingChanges = breakingChangesInput.map<BreakingChange>((changes) => {
    return {
      ...changes,
      fixed: getLines(changes.fixed),
      changed: getLines(changes.changed),
      added: getLines(changes.added),
      removed: getLines(changes.removed),
    };
  });

  return { breakingChanges, status, error };
}
